import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download_staging/6a089bc2f6558f0014c077d8_1787320879085_a6b5c096/tradecontrol/src/app/sign-up-login/components/AuthScreen.tsx");
